import { render, staticRenderFns } from "./SuperAdminDashboardView.vue?vue&type=template&id=3f990616&scoped=true"
import script from "./SuperAdminDashboardView.vue?vue&type=script&lang=js"
export * from "./SuperAdminDashboardView.vue?vue&type=script&lang=js"
import style0 from "./SuperAdminDashboardView.vue?vue&type=style&index=0&id=3f990616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f990616",
  null
  
)

export default component.exports